<template>
    <v-card class="detail-card">
      <v-card-title>
        <h3>{{title}}</h3>
      </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="computedHeaders"
        :items="items"
        hide-actions
        class="elevation-1"
        item-key="id"
        no-data-text="No hay información que mostrar"
      >
      <template v-slot:items="props">
          <td class="text-xs-left" v-if="showRoute">
            <router-link :to="routeLink(props.item)">{{ props.item.route_description }}</router-link>
          </td>
          <td class="text-xs-rigth">{{ props.item.weigth }}</td>
          <td class="text-xs-right">{{ props.item.price_per_kilo }}</td>
          <td class="text-xs-right">{{ props.item.is_diesel }}</td>
          <td ><v-icon color="red" @click="deleteItem(props.item)">delete_forever</v-icon></td>
      </template>
      <template slot="footer">
        <tr>
          <td><strong>Totales</strong> {{totals.weigth}}</td>
          <td class="text-xs-right"></td>
          <td>&nbsp;</td>
          <td>&nbsp;</td>
        </tr>
      </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { PUOND_CONVERT } from '../../utils/constants';
export default {
  props: {
    items: Array,
    title: String,
    showRoute: {
      type: Boolean,
      default: false,
    },
    showDetails: {
      type: Boolean,
      default: true,
    },
    showOperations: {
      type: Boolean,
      default: true,
    },
    currentBag: {
      type: Object,
    },
  },
  data() {
    return {
      detailHeaders: [
        { text: 'Ruta', value: 'route_description'},
        { text: 'Peso', value: 'weigth', width: '1%' },
        { text: 'Precio', value: 'price_per_kilo', width: '1%' },
        { text: 'Diesel', value: 'is_diesel', width: '1%' },
        { text: '', width: '1%', sortable: false },
      ],
    };
  },
  methods: {
    deleteItem(event) {
      this.$emit('deleteItem', event);
    },
    routeLink(row) {
      return `/bag/${this.currentBag.id}/route/${row.route_id}`;
    },
  },
  computed: {
    totals() {
      if (!this.items || this.items.length === 0) {
        return {
          weigth: 0,
          price_per_kilo: 0,
        };
      } else {

        const results = {
          weigth: 0,
          price_per_kilo: 0,

        };
        for (const line of this.items) {
          results.weigth += parseFloat(line.weigth, 10);
          results.price_per_kilo += parseFloat(line.price_per_kilo);
        }
        return results;
      }
    },
    computedHeaders() {
      let results = this.detailHeaders;
      if (!this.showRoute) {
        results = results.filter((e) => {
          return e.text !== 'Ruta';
        });
      }
      return results;
    },
  },
};
</script>
